import { Injectable } from '@angular/core';

import { TmsWebBaseEditService } from '../base';
import { CollectionLookupResult } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class CustomerCollectionProductService extends TmsWebBaseEditService<
  CollectionLookupResult,
  CollectionLookupResult
> {
  constructor() {
    super('CustomerCollectionProduct', $localize`Customer Collection Product`);
  }
}
